import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GuestSelect } from '../../../../components/NumberSelect';
import { updateBookingAction } from '../../../../data/actions/bookingAction';
import { bookingKeys, bookingPropTypes } from '../../../../data/models/Booking';
import { restaurantPropTypes } from '../../../../data/models/Restaurant';
import { getMinMaxGroupSize } from '../../../../data/models/obeeAreas';
import { trackEvent } from '../../../../utils/analytics';

const Guests = ({ booking, restaurant, updateBooking }) => {
  const { minGroup, maxGroup } = getMinMaxGroupSize(restaurant.data.areas, booking.areaId);

  // we want the user to be able to select outside of the min max range we we can prompt them with a custom message alert
  const minGroupCap = Math.max(1, minGroup - 1);
  const maxGroupCap = maxGroup + 1;

  return (
    <GuestSelect
      value={booking.guests}
      max={maxGroup}
      min={minGroupCap}
      allowMaxPlusOne={restaurant.data?.showOverfilledGuests}
      onDecrease={() => {
        trackEvent('Booking', 'Updating Guests', 'Decrement');
        updateBooking(bookingKeys.guests, Math.max(booking.guests - 1, minGroupCap));
        updateBooking(bookingKeys.selectedExperiences, []);
      }}
      onIncrease={() => {
        trackEvent('Booking', 'Updating Guests', 'Increment');
        updateBooking(bookingKeys.guests, Math.min(booking.guests + 1, maxGroupCap));
        updateBooking(bookingKeys.selectedExperiences, []);
      }}
      onSetValue={(newValue) => {
        trackEvent('Booking', 'Updating Guests', 'Increment');
        updateBooking(bookingKeys.guests, newValue);
        updateBooking(bookingKeys.selectedExperiences, []);
      }}
    />
  );
};

Guests.propTypes = {
  booking: bookingPropTypes.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  updateBooking: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateBooking: updateBookingAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Guests);
